import AddButton from './AddButton'
import PrintButton from './PrintButton'
import SelectionButton from './SelectionButton'

export const createButtonList = ({
  isReadOnly,
  isEnable,
  enableSelectionButton,
  uischema,
  tableColumn,
  showAddButton,
  rowPanelAdd,
  setRowPanelAdd,
  setLoading,
  handleChangePage,
  onRowDefaultAction,
  addActionRef,
  page,
  rowsPerPage,
  totalCount,
  showPrintButton,
  formData,
  rowSelection,
  showSelectionButton,
  renderTableData,
}) => ({
  add:
    !isReadOnly && isEnable ? (
      <AddButton
        uischema={uischema}
        tableColumn={tableColumn}
        stateParent={{
          showAddButton,
          rowPanelAdd,
          setRowPanelAdd,
          setLoading,
        }}
        actionParent={{ handleChangePage, onRowDefaultAction }}
        addActionRef={addActionRef}
        pagination={{ page, rowsPerPage, totalCount }}
      />
    ) : (
      <></>
    ),
  print: (
    <PrintButton
      showPrintButton={showPrintButton}
      formData={formData}
      rowSelection={rowSelection}
    />
  ),
  selection:
    !isReadOnly && isEnable && enableSelectionButton ? (
      <SelectionButton
        showSelectionButton={showSelectionButton}
        uischema={uischema}
        rowSelection={rowSelection}
        renderTableData={renderTableData}
      />
    ) : (
      <></>
    ),
})
